import { render, staticRenderFns } from "./GroupFollowupRuleDialog.vue?vue&type=template&id=5f002dae&scoped=true&"
import script from "./GroupFollowupRuleDialog.vue?vue&type=script&lang=js&"
export * from "./GroupFollowupRuleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f002dae",
  null
  
)

export default component.exports